import React, { Fragment } from 'react';
import Loader from '../../atoms/Loader';
import TokenManager from '../../utils/TokenManager';
const SingleSignon = props => {
  const {
    BASE_URL,
    AUTHORIZATION_SERVER_ID,
    clientId,
    authenticateApiUrl,
    redirectUri,
    scope
  } = props;
  const renderComponent = () => {
    const {
      search,
      hash
    } = window.location;
    if (hash && hash.includes('#access_token=')) {
      const rawToken = hash.split('#access_token=')[1];
      const accessToken = rawToken.split('&token_type=')[0];
      const options = {
        authenticateApiUrl: "".concat(BASE_URL).concat(authenticateApiUrl),
        redirectUrl: '/app/home'
      };
      TokenManager.persistUserAuth({
        accessToken: {
          accessToken
        }
      }, options);
    } else if (search && search.includes('?iss=')) {
      const domain = decodeURIComponent(search.split('?iss=')[1]);
      const randomString = new Date().getTime().toString(16);
      const queryParam = "client_id=".concat(clientId, "&response_type=token&scope=").concat(scope, "&redirect_uri=").concat(redirectUri, "&nonce=").concat(randomString, "&state=state-").concat(randomString);
      const redirectDomain = "".concat(domain, "/oauth2/").concat(AUTHORIZATION_SERVER_ID, "/v1/authorize?").concat(queryParam);
      window.location = redirectDomain;
    } else {
      TokenManager.clearTokenDetails();
      TokenManager.clearAllCookies();
    }
    return /*#__PURE__*/React.createElement(Loader, {
      id: "tap-login-callback-loader",
      top: "0"
    });
  };
  return /*#__PURE__*/React.createElement(Fragment, null, renderComponent());
};
export default SingleSignon;